import { render } from "./PrayersList.vue?vue&type=template&id=3806a26a&scoped=true"
import script from "./PrayersList.vue?vue&type=script&lang=js"
export * from "./PrayersList.vue?vue&type=script&lang=js"

import "./PrayersList.vue?vue&type=style&index=0&id=3806a26a&scoped=true&lang=css"

import exportComponent from "/Users/q/Documents/projects/religious-app/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3806a26a"]])

export default __exports__